import React from "react";
import classes from "./BoxLayout.module.scss";
const BoxLayout = ({
  height,
  minHeight,
  width,
  padding = [2, 2, 2, 2],
  margin = [0, 0, 0, 0],
  children,
}) => {
  return (
    <div
      className={classes.boxLayout}
      style={{
        height: height ? height + "rem" : "100%",
        minHeight: minHeight ? minHeight + "rem" : "100%",
        width: width ? width + "rem" : "100%",
        padding: `${padding[0]}rem ${padding[1]}rem ${padding[2]}rem ${padding[3]}rem`,
        margin: `${margin[0]}rem ${margin[1]}rem ${margin[2]}rem ${margin[3]}rem`,
      }}
    >
      {children}
    </div>
  );
};

export default BoxLayout;
